/* template */
<template><Popup :show="(isPopupShow)" :closeable="(false)"><div class="success-popup-container"><mpx-image src="https://ut-static.udache.com/webx/sfc/SRVycloESs8uAt7WibScn_guang.apng" mode="widthFix" class="light-pic"/><mpx-image src="https://ut-static.udache.com/webx/sfc/7R_1rEVMK7Vm_wgaQRKPQ.png" class="success-pic"/><div class="coupon-list-wrapper"><div class="coupon-list"><div class="coupon-list-title"><div class="coupon-list-title-item">恭喜你</div><div class="coupon-list-title-item">获得价值{{ totalAmount }}元券包</div></div><div v-for="(item, index) in (rewardCouponList)" class="reward-coupon-item"><div class="reward-coupon-item-left"><div class="price"><div class="num">{{ getAmount(item) }}</div><div class="unit">元</div></div></div><div class="reward-coupon-item-right"><div class="name" v-if="(item.name)">{{ item.name }}</div><div class="remark" v-if="(item.remark)">{{ item.remark }}</div></div></div></div></div><mpx-image src="https://ut-static.udache.com/webx/sfc/mbMgwUYV-8Kyax9b6G-5f.png" mode="widthFix" @tap="receive" class="btn-pic"/><mpx-image @tap="close" src="https://ut-static.udache.com/webx/sfc/zDAAD6_KoVVbL7DpWKbcG.png" class="close-icon"/></div></Popup></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m89d103a4"}'>
  .success-popup-container
    width 270px
    border-radius 37.5px
    position relative
    .coupon-list-wrapper
      width 100%
      position relative
      padding 7px 8.5px 8px 8.5px
      border-radius 37.5px
      box-sizing border-box
      z-index 2
      background #FF6B35
      .coupon-list
        position relative
        z-index 2
        height 100%
        padding 16px 17px 78px 17px
        display flex
        flex-direction column
        align-items center
        border-radius 30.5px
        box-sizing border-box
        border 3.5px solid #FFFFFF
        -webkit-mask radial-gradient(circle at 7.5px 80px, transparent 7.5px, #000 0) -7.5px
        mask radial-gradient(circle at 7.5px 80px, transparent 7.5px, #000 0) -7.5px
        background linear-gradient(243deg, rgba(255, 254, 252, 0.9) 0%, rgba(255, 252, 242, 0.9) 60%, rgba(255, 251, 238, 0.9) 98%), linear-gradient(340deg, rgba(255, 242, 209, 0) 71%, rgba(122, 232, 255, 0.353) 106%), linear-gradient(49deg, rgba(255, 255, 255, 0) 54%, #F5FFDA 110%), #FFFFFF
        &-title
          display flex
          flex-direction column
          align-items center
          font-family PingFangSC-Semibold
          font-size 21px
          font-weight 600
          letter-spacing 0px
          color #FF6427
          margin-bottom 8px
          &-item
            line-height 25px
            &:not(:last-child)
              margin-bottom 1.5px
        .reward-coupon-item
          width 100%
          position relative
          height 56px
          display flex
          align-items center
          background linear-gradient(264deg, #FFF5B5 -63%, #FFF9E7 67%, #FFFAEA 99%)
          border 1px solid #FFE0AD
          box-sizing border-box
          border-radius 10px
          &:not(:last-child)
            margin-bottom 8px
          .reward-coupon-item-left
            width 71.5px
            height 100%
            display flex
            justify-content center
            align-items center
            .price
              display flex
              justify-content center
              align-items baseline
              .num
                font-family Barlow Semi Condensed
                font-size 30px
                font-weight 400
                line-height 30px
                letter-spacing 0px
                color #FF6427
              .unit
                font-family PingFangSC-Regular
                font-weight 400
                font-size 14px
                line-height 14px
                text-align center
                letter-spacing 0px
                color #FF6427
          .reward-coupon-item-right
            flex 1
            padding-left 20px
            display flex
            flex-direction column
            justify-content center
            .name
              font-family PingFangSC-Semibold
              font-size 14px
              font-weight 600
              line-height 14px
              letter-spacing 0px
              color #543018
              margin-bottom 4px
            .remark
              font-family PingFangSC-Regular
              font-weight 400
              font-size 10px
              line-height 10px
              letter-spacing 0px
              color #B98664
    .light-pic
      width 130vw
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      z-index 1
    .success-pic
      position absolute
      top -96.5px
      left 50%
      transform translateX(-50%)
      height 124px
      width 310px
      z-index 2
    .btn-pic
      width 100%
      position absolute
      bottom -49px
      left 0
      z-index 2
    .close-icon
      height 36px
      width 36px
      position absolute
      bottom -114.5px
      left 50%
      transform translateX(-50%)
      z-index 2
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m89d103a4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./success-popup.mpx.js?isComponent&outputPath=components%2Fsuccess-popup89d103a4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./success-popup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsuccess-popup89d103a4%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m89d103a4"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/success-popup89d103a4/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Popup':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-popup/index.mpx?isComponent&outputPath=components%2Findex0ce21716%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
